import React from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { Button, Modal, ModalHeading, Text } from '@components/common';
import { useDisabledFeatures } from '@hooks/useDisabledFeatures';

type Props = {
  onClose: () => void;
  team: Team;
};

export const CreateTeamStudyModal: React.FC<React.PropsWithChildren<Props>> = ({ onClose, team }) => {
  const navigate = useNavigate();
  const { disabledFeatures } = useDisabledFeatures();

  return (
    <Modal
      size='md'
      onClose={onClose}
      renderFooter={() => (
        <>
          <Button onClick={() => navigate(`/teams/${team.id}/studies`)}>View existing team studies</Button>
          <Button onClick={() => navigate(`/teams/${team.id}/studies/new`)} primary>
            Create new team study
          </Button>
        </>
      )}
    >
      <ModalHeading className='mb-4 mr-6'>Team repository artifacts must be added within a team study</ModalHeading>
      <section className='mb-6 mt-2'>
        <Text h='400' mb='4'>
          In order to add artifacts to the {team.name} repository, please add them to a team study.
        </Text>
        {!disabledFeatures.repository_workspace && (
          <Text h='400'>
            Alternatively, you can go to the <Link to='/repository'>workspace repository</Link> to add artifacts outside
            of a study.
          </Text>
        )}
      </section>
    </Modal>
  );
};
